<app-banner-info [rolesCanShowBanner]="rolesCanShowBannerInfo"
                    [situation]="displayApplication">
</app-banner-info>

<mat-toolbar class="gamecode-list__filters filters">
    <mat-toolbar-row class="gamecode-list__filter-row">
        <app-search-filters (launchSearch)="refreshNotes($event).subscribe()"
                            [countEntities]="paginator?.count"
                            [customLists]="{lessons: alreadyAssociatedLessonsFilterList}"
                            [fields]="filters"
                            [customFieldName]="[{field: 'metadatas_title', value: 'generic.title'}]">
        </app-search-filters>
    </mat-toolbar-row>
</mat-toolbar>

@if (isLoadingDone) {
    @if (this.gamecodes.length === 0) {
        <div class="gamecode-list__help-message">
            <p>{{ 'gamecode.empty_list' | translate }}</p>
            <p>{{ 'gamecode.add_gamecode_instruction' | translate }}</p>
        </div>
    }
    <div class="gamecode-list__cards">
        <button class="gamecode-list__add-button"
                (click)="createNote($event)"
                (keyup.enter)="createNote($event)">
            <mat-icon svgIcon="add"></mat-icon>
            <span>{{ (displayApplication + '.add_note') | translate}}</span>
        </button>
        @for (gamecode of gamecodes; track $index) {
            <app-gamecode-card (hasChanged)="onGamecodeChanged(gamecode)"
                                [gamecodeBasicSearchEntity]="gamecode">
            </app-gamecode-card>
        }
    </div>
    <mat-paginator (page)="onPaginateChange($event)"
                    [length]="paginator.count"
                    [pageIndex]="paginator.page -1"
                    [pageSize]="gamecodeListRange">
    </mat-paginator>
} @else {
    <mat-spinner></mat-spinner>
}
